import React from 'react';
import { useDroppable, useDraggable } from '@dnd-kit/core';

export const DroppableColumn = ({ id, className, testId, children }) => {
  const { setNodeRef, isOver } = useDroppable({ id });
  return (
    <div
      ref={setNodeRef}
      data-testid={testId}
      data-drop-over={isOver ? 'true' : 'false'}
      className={`${className} transition-[box-shadow,background-color] duration-150 ${isOver ? 'ring-2 ring-[#D93025]/50 ring-offset-2' : ''}`}
    >
      {children}
    </div>
  );
};

export const DraggableCard = ({ id, children }) => {
  const { setNodeRef, listeners, isDragging } = useDraggable({ id });
  return (
    <div ref={setNodeRef} {...listeners} className={`cursor-grab active:cursor-grabbing ${isDragging ? 'opacity-30' : ''}`} data-testid={`draggable-${id}`}>
      {children}
    </div>
  );
};
